import React from 'react';
import { Form } from 'react-bootstrap-5';
import OutOfCreditsAlert from './out_of_credits_alert';

export type IncludeOwnerDataCheckboxProps = {
  checked: boolean;
  disabled?: boolean;
  onChange: () => void;
  cannotIncludeContacts?: boolean;
}

export default function IncludeOwnerDataCheckbox({ checked,
  disabled = false,
  onChange,
  cannotIncludeContacts }: IncludeOwnerDataCheckboxProps) {
  return (
    <>
      <Form.Check
        checked={checked}
        className="d-flex gap-1 align-items-center"
        disabled={disabled}
        id="save-contact-to-rethink-modal-checkbox"
        label="Include owner contact data"
        type="checkbox"
        onChange={onChange}
      />
      <p className="text-muted ms-6">
        This will expend an owner unlock credit unless you have previously unlocked the owner for this property.
      </p>
      {
        cannotIncludeContacts && (
          <OutOfCreditsAlert />
        )

      }
    </>
  );
}
